export interface EmailAcknowledgeRequestModel {
  token: string;
}
